import React from 'react';
import './Hero.css';
import profileImg from '../assets/images/profile-photo.jpg';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-image" style={{backgroundImage: `url(${profileImg})`}}></div>
      <div className="hero-text">
        <h2>Hi,</h2>
        <h1>I am Nimisha Thallapally</h1>
        <p>
          A passionate Btech Computer Science student interested in software development 
          and keen to contribute to the ongoing research in the field of computer science
        </p>
      </div>
    </section>
  );
};

export default Hero;
